import { useState, useEffect } from 'react'
import { pb } from '@/pb'
import { 
  TextField, CircularProgress
} from '@mui/material'
import Autocomplete from '@mui/material/Autocomplete';



export const PBAutocomplete = ({ 
  collectionName, 
  label, 
  value, 
  onChange, 
  searchFields = [], 
  getOptionLabel, 
  getOptionDisabled,
  sx 
}) => {
  const [searchTerm, setSearchTerm] = useState('')
  const [options, setOptions] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const fetchRecords = async () => {
      setLoading(true)
      try {
        let filterQuery = ""
        if (searchTerm && searchFields.length > 0) {
          const filterString = searchFields.map(field => `${field} ~ {:search}`).join(' || ')
          filterQuery = pb.filter(filterString, { search: searchTerm })
        }
        
        const result = await pb.collection(collectionName).getList(1, 30, {
          filter: filterQuery,
          sort: '-created',
        })
        setOptions(result.items)
      } catch (error) {
        if (!error.isAbort) console.error(`Failed to fetch ${collectionName}:`, error)
      } finally {
        setLoading(false)
      }
    }

    const timeoutId = setTimeout(fetchRecords, 300)
    return () => clearTimeout(timeoutId)
  }, [searchTerm, collectionName, searchFields])

  return (
    <Autocomplete
      options={options}
      loading={loading}
      getOptionLabel={getOptionLabel}
      getOptionDisabled={getOptionDisabled}
      value={value}
      onChange={onChange}
      onInputChange={(_, newInputValue) => setSearchTerm(newInputValue)}
      filterOptions={(x) => x} 
      isOptionEqualToValue={(option, val) => option.id === val?.id}
      renderInput={(params) => (
        <TextField 
          {...params} 
          label={label} 
          size="small"
          slotProps={{
            input: {
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }
          }}
        />
      )}
      sx={sx}
    />
  )
}